import type { FaqItem, TimelineEvent } from '@/types/content';

export const siteName = '独家黑料档案中心';

export const siteBrand = '独家黑料';

export const siteTagline = '档案人物库 · 历史记录深挖';

export const contactEmail = 'archive@heiliao-archive.com';

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '档案人物库', path: '/figures' },
  { label: '秘史专题', path: '/topics' },
  { label: '关于档案中心', path: '/about' },
];

export const siteStats = [
  { label: '收录人物档案', value: '128', unit: '位' },
  { label: '整理历史记录', value: '502', unit: '条' },
  { label: '专题线索稿', value: '96', unit: '篇' },
  { label: '可公开核对条目', value: '2,140', unit: '项' },
];

export const faqs: FaqItem[] = [
  {
    question: '“独家黑料档案”里的内容是怎么来的？',
    answer:
      '档案中心只整理已公开或可公开核对的材料，包括通讯稿、节目单、场记单、版权登记与公开访谈。所有条目都会标注来源类型与时间，读者可以自行比对，而不必依赖单一说法。',
  },
  {
    question: '为什么有的内容看起来信息不完整？',
    answer:
      '很多旧事的原始材料本就残缺。我们不会为了叙事完整而补写细节，而是把缺口明确标出来，交给时间线去说明哪里还缺一块拼图。',
  },
  {
    question: '档案中心会收录个人隐私信息吗？',
    answer:
      '不会。档案中心关注的是公开履历、作品署名、合作关系与事件时间线，不收录与公共事务无关的个人隐私，也不会发布未经核对的私人信息。',
  },
  {
    question: '“档案人物库”按什么标准收录人物？',
    answer:
      '收录对象以在公开作品或公开活动中留下明确记录的人物为主，且至少有一个可核对的档案来源。同一人物下的条目会按时间顺序排列，方便查看前后关系。',
  },
  {
    question: '秘史专题和普通的长文有什么区别？',
    answer:
      '普通长文往往只讲结论，秘史专题会把论证过程也放出来：用了哪些材料、哪些地方存在分歧、哪些结论仍然存疑，都写在正文里。',
  },
  {
    question: '如果发现档案里的信息有误怎么办？',
    answer:
      '可以通过联系邮箱提交更正请求，并附上可公开核对的材料。我们会在核对之后更新对应条目，并在条目下方保留修订提示。',
  },
  {
    question: '档案中心的内容可以转载吗？',
    answer:
      '欢迎在注明来源并保留原文链接的前提下转载，但不得对原文进行断章取义的删改。如需用于商业用途，请先通过联系邮箱取得授权。',
  },
];

export const siteTimeline: TimelineEvent[] = [
  {
    year: '1992',
    title: '档案线索的起点',
    desc: '第一批通讯稿、节目单与场记单进入整理范围，形成最初的三百条索引。',
  },
  {
    year: '1998',
    title: '第一次系统比对',
    desc: '整理组开始对同一事件的多个版本做交叉比对，确立“疑点单独标注”的规则。',
  },
  {
    year: '2006',
    title: '人物库雏形',
    desc: '以人物为单位的归档方式逐渐成型，公开行程与作品署名被拆分为独立条目。',
  },
  {
    year: '2014',
    title: '时间线方法确立',
    desc: '引入以日期为轴的重组方式，让大量碎片化信息第一次能够被连续阅读。',
  },
  {
    year: '2019',
    title: '资料考据专栏上线',
    desc: '专门处理笔迹、批注与版本差异，只保留可被公开核对的结论。',
  },
  {
    year: '2024',
    title: '公开档案条目破两千',
    desc: '可公开核对的条目累计超过两千项，人物档案覆盖影视、音乐、电视与传媒四个领域。',
  },
];

export const aboutPrinciples = [
  {
    icon: 'ri-search-eye-line',
    title: '先材料，后结论',
    desc: '每一篇专题都先说明用了哪些材料，再给出判断，避免先有立场再找证据。',
  },
  {
    icon: 'ri-ball-pen-line',
    title: '标注疑点',
    desc: '材料互相矛盾时不做强行统一，而是把分歧原样保留，交给读者判断。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '守住边界',
    desc: '只整理与公开事务相关的记录，不触碰与公共讨论无关的个人隐私。',
  },
  {
    icon: 'ri-refresh-line',
    title: '允许修订',
    desc: '出现新的可核对材料时更新条目，并保留修订痕迹，让结论经得起回看。',
  },
];

export const testimonials = [
  {
    name: '影评作者 · 陈屿',
    role: '长期关注华语影视史',
    quote:
      '档案中心最难得的是把缺口也标出来。很多旧事本来就说不清，愿意承认“这里还缺一块”的整理方式反而更可信。',
  },
  {
    name: '资料馆编辑 · 何楠',
    role: '地方影像资料整理',
    quote:
      '时间线整理这个栏目帮了大忙。把零散的公开通告按日期摆开，一条脉络自己就浮出来了，比读十篇结论文都有用。',
  },
  {
    name: '独立撰稿人 · 郑书遥',
    role: '文化与人物报道',
    quote:
      '考据栏目对版本差异的处理非常克制，不夸张也不猎奇，引用来源清楚，适合作为写作前的资料索引。',
  },
  {
    name: '播客主理人 · 罗青',
    role: '一档聊旧事的音频节目',
    quote:
      '做选题时会先来这里对时间线，凡是标注为“存疑”的部分我都不会直接引用，这种清清楚楚的标注特别省事。',
  },
];